import script from "./AddNews.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddNews.vue?vue&type=script&lang=ts&setup=true"

import "./AddNews.vue?vue&type=style&index=0&id=5928569c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5928569c"]])

export default __exports__